import { render, staticRenderFns } from "./applicant-master-profile.vue?vue&type=template&id=080ecc13&scoped=true"
import script from "./applicant-master-profile.vue?vue&type=script&lang=js"
export * from "./applicant-master-profile.vue?vue&type=script&lang=js"
import style0 from "./applicant-master-profile.vue?vue&type=style&index=0&id=080ecc13&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "080ecc13",
  null
  
)

export default component.exports